module.exports = __webpack_public_path__ + "img/intel.95b4cdf0.svg";